module.exports = __webpack_public_path__ + "static/media/gryllus_campestris.2f2ffff7.mp3";